"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _models = require("@seedlang/models");
var _root_store = _interopRequireDefault(require("./root_store"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var FollowAssociationStore = /*#__PURE__*/function (_RootStore) {
  function FollowAssociationStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, FollowAssociationStore);
    _this = _callSuper(this, FollowAssociationStore);
    _this.config = {
      model: _models.FollowAssociation,
      deserialize: true,
      GET: {
        index: '/follow_associations',
        finishedMatchInTreeNode: '/follow_associations/finished_match_in_tree_node'
      },
      POST: {
        create: '/follow_associations'
      },
      DELETE: {
        destroy: '/follow_associations/:followAssociationId'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(FollowAssociationStore, _RootStore);
  return (0, _createClass2["default"])(FollowAssociationStore, [{
    key: "finishedMatchInTreeNode",
    value: function finishedMatchInTreeNode(params, callback) {
      this.api(params, callback, 'GET', 'finishedMatchInTreeNode');
    }
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new FollowAssociationStore();